// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"ffd5f6d7","367":"ffd5f6d7","900":"ffd5f6d7"}[chunkId] + ".chunk.css";
};